module.exports = __webpack_public_path__ + "img/My Ex-bf is a space.8ad44bfe.jpg";